import { type ReactNode } from 'react';
import { Badge, type BadgeProps } from './badge';

// Re-authored from ../design-system/components/badges/StatusBadge.jsx.
// Composes the R2a Badge (status → Badge variant + dot + label) — DRY.

// Domain/DB uses snake_case (checked_in, checked_out, no_show); callers mapping
// API data must convert to these hyphenated UI values.
export type ReservationStatus =
  | 'confirmed'
  | 'pending'
  | 'cancelled'
  | 'checked-in'
  | 'checked-out'
  | 'no-show'
  | 'inquiry'
  | 'cleaning';

export interface StatusBadgeProps {
  status: ReservationStatus;
  square?: boolean;
  children?: ReactNode;
}

const STATUS: Record<ReservationStatus, { label: string; variant: NonNullable<BadgeProps['variant']> }> = {
  confirmed: { label: 'Confirmed', variant: 'success' },
  pending: { label: 'Pending', variant: 'warning' },
  cancelled: { label: 'Cancelled', variant: 'danger' },
  'checked-in': { label: 'Checked In', variant: 'info' },
  'checked-out': { label: 'Checked Out', variant: 'neutral' },
  'no-show': { label: 'No-show', variant: 'danger' },
  inquiry: { label: 'Inquiry', variant: 'navy' },
  cleaning: { label: 'Cleaning', variant: 'gold' },
};

export function StatusBadge({ status, square, children }: StatusBadgeProps) {
  const s = STATUS[status];
  return (
    <Badge variant={s.variant} dot square={square}>
      {children ?? s.label}
    </Badge>
  );
}
